import { render, staticRenderFns } from "./MarketGroupList.vue?vue&type=template&id=3f61f1be&scoped=true&"
import script from "./MarketGroupList.vue?vue&type=script&lang=js&"
export * from "./MarketGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61f1be",
  null
  
)

export default component.exports